import axiosInstance from "./api";

// Add methods for create, delete, and modify
axiosInstance.createPackage = (data) =>
  axiosInstance.post("/packages/create", data);
axiosInstance.deletePackage = (packageId) =>
  axiosInstance.delete(`/packages/${packageId}`);
axiosInstance.modifyPackage = (packageId, data) =>
  axiosInstance.patch(`/packages/${packageId}/modify`, data);

// Add other necessary methods
axiosInstance.getAllPackages = () => axiosInstance.get("/packages");
axiosInstance.getManagerPackages = (managerId) =>
  axiosInstance.get(`/packages/manager/${managerId}`);
axiosInstance.getPackage = (packageId) =>
  axiosInstance.get(`/packages/${packageId}`);
axiosInstance.updatePackage = (packageId, data) =>
  axiosInstance.put(`/packages/${packageId}`, data);

export default axiosInstance;
